/**
 * La Sura - slim header after scrolling (header direction A, Matt, 2026-09-27).
 * Loaded by snippets/lasura-header-variables.liquid when Theme settings > La Sura brand >
 * Header > "Slim the header after scrolling" is on. The look is in lasura-foundations.css
 * (section 14); this only sets data-lasura-slim on Horizon's #header-component.
 *
 * Why not just Horizon's data-sticky-state: the header is sticky, so it stays in the page
 * flow. Shrinking it the moment it sticks makes the page below move up by the height it
 * lost, the browser's scroll anchoring pulls the scroll position back by the same amount,
 * the header un-sticks and grows, and it flickers. So the header slims a good way past the
 * point where it sticks and only grows again close to it: the gap between the two is wider
 * than the height it loses, so one change can never trigger the other.
 */

const SLIM_AFTER = 140; // px scrolled past the point where the header sticks
const GROW_BEFORE = 24; // px from that point

/* Looked up on each use: the theme editor re-renders the header section in place. */
const getHeader = () => document.getElementById('header-component');

if (getHeader()?.hasAttribute('sticky')) {
  let stickAt = 0;
  let slim = false;
  let frame = 0;

  /* The header sticks once the sections above it in the header group (the utility bar, the
     announcement bar) have scrolled away, so the point is their combined height. */
  const measure = () => {
    let top = 0;
    let section = getHeader()?.closest('.shopify-section')?.previousElementSibling;
    while (section) {
      if (section.classList.contains('shopify-section-group-header-group')) top += section.offsetHeight;
      section = section.previousElementSibling;
    }
    stickAt = top;
  };

  const update = () => {
    frame = 0;
    const y = window.scrollY;
    if (!slim && y > stickAt + SLIM_AFTER) slim = true;
    else if (slim && y < stickAt + GROW_BEFORE) slim = false;
    else return;
    getHeader()?.toggleAttribute('data-lasura-slim', slim);
  };

  const queue = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  measure();
  update();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener(
    'resize',
    () => {
      measure();
      queue();
    },
    { passive: true }
  );
}
